import { useEffect, useRef } from "react";
import useLoadingBackdropOverlayContext from "./useLoadingBackdropOverlayContext";

export const useCloseLoadingBackdropOverlay = ({
    closeTimeoutMilliseconds = 0
} = {}) => {
    const loadingBackdropOverlay = useLoadingBackdropOverlayContext();
    const loadingBackdropOverlayRef = useRef(loadingBackdropOverlay);
    loadingBackdropOverlayRef.current = loadingBackdropOverlay;

    useEffect(() => {
        const {
            onClose
        } = loadingBackdropOverlayRef.current;

        const timer = setTimeout(onClose, closeTimeoutMilliseconds);

        return () => clearTimeout(timer);
    }, [closeTimeoutMilliseconds]);
};

export default useCloseLoadingBackdropOverlay;
